import { ChevronRight } from "lucide-react";

import { useArtwork } from "@design-lab/entities/artwork";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { useProcessingTooltip } from "@design-lab/shared/hooks/useProcessingTooltip";
import { Button } from "@design-lab/shared/ui";
import { useTab } from "@design-lab/shared/ui/layouts/state";
import { Tooltip, TooltipContent, TooltipTrigger } from "@design-lab/shared/ui/tooltip";

export function NextButton() {
  const { isDesktop } = useResponsive();
  const { isValid, canGoNext, next, nextTab } = useTab();
  const { front, back } = useArtwork();

  const frontHasLoading = front.state.hasTag("loading");
  const backHasLoading = back.state.hasTag("loading");

  const shouldShowTooltip = frontHasLoading || backHasLoading;

  const { showTooltip, dismissTooltip } = useProcessingTooltip({ shouldShow: shouldShowTooltip });

  if (!canGoNext) {
    return null;
  }

  return (
    <Tooltip open={showTooltip}>
      <TooltipTrigger asChild data-testid="next-button-tooltip-trigger">
        <Button
          data-testid="next-button"
          variant="destructive"
          isDisabled={!isValid}
          onPress={next}
          className={
            isDesktop
              ? "text-background min-h-12 w-fit bg-blue-700 hover:bg-blue-800"
              : "h-12 w-full"
          }
        >
          {isDesktop ? (
            <>
              Next <ChevronRight />
            </>
          ) : (
            <>
              Next: {nextTab?.mobileTitle || nextTab?.title} <ChevronRight />
            </>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent
        side={isDesktop ? "right" : "bottom"}
        align={"end"}
        onClose={dismissTooltip}
        className="bg-blue-700"
        arrowClassName="bg-blue-700 fill-blue-700"
      >
        <p className={isDesktop ? undefined : "text-sm"}>
          While the image is being processed
          {isDesktop ? <br /> : " "}
          continue to add colors and more products.
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
